"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isSet = _interopRequireDefault(require("./isSet"));

var isEmptySet = function isEmptySet(obj) {
  return !(0, _isSet["default"])(obj) || obj.size === 0;
};

var _default = isEmptySet;
exports["default"] = _default;